import { z } from "zod/v4";

import { ExperienceDtoSchema } from "../../dtos/experiences";
import { RedirectDtoSchema } from "../../dtos/redirects";
import { castToBool, castToNumber } from "../../utils";

import {
  AnalyzeContext,
  BaseAnalyticsPayloadSchema,
  CastedTimes,
} from "./base";

// The request from BE > Analytics
export const FileExportAnalyticsPayloadSchema =
  BaseAnalyticsPayloadSchema.extend({
    resourceType: z.literal("experiences"),
    experienceId: z.uuid(),
    testOrdersOnly: castToBool.nullable(),
    maxZScore: castToNumber.nullable(),
    discountIncludeType: z.number().nullable(),
    viewedRedirectOnly: z.boolean().nullable(),
    userBehavior: z.object({
      viewedCheckout: z.boolean().nullable(),
      addedToCart: z.boolean().nullable(),
    }),
    customEvents: z.string().array(),
    excludeIpAddresses: z.string().array(),
    onlyProductIds: z.string().array().nullish(),
  });

export type FileExportAnalyticsPayloadType = z.infer<
  typeof FileExportAnalyticsPayloadSchema
>;

// The request from FE > Backend
export const FileExportAnalyticsRequestBodySchema =
  FileExportAnalyticsPayloadSchema.omit({
    viewedRedirectOnly: true,
    shopifyDomain: true,
    latestRunTs: true,
    timezone: true,
  });

export type FileExportAnalyticsRequestBodyType = z.infer<
  typeof FileExportAnalyticsRequestBodySchema
> &
  CastedTimes;

const FileExportAnalyticsContextSchema = AnalyzeContext.extend({
  experience: ExperienceDtoSchema,
  redirects: RedirectDtoSchema.array(),
  onlyProductIds: z.string().array().nullish(),
});

export type FileExportAnalyticsContextType = z.infer<
  typeof FileExportAnalyticsContextSchema
>;
